import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "overlay"
}
const _hoisted_2 = {
  key: 2,
  class: "loading__container"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "loading--icon icon-spinner animate-spin" }, null, -1)
const _hoisted_4 = {
  key: 3,
  id: "modals"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" /> ")
const _hoisted_6 = {
  key: 4,
  id: "popups"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheNavbar = _resolveComponent("TheNavbar")
  const _component_router_view = _resolveComponent("router-view")
  const _component_ResizeObserver = _resolveComponent("ResizeObserver")
  const _component_TheJoinTeamDialog = _resolveComponent("TheJoinTeamDialog")
  const _component_ThePreferencesDialog = _resolveComponent("ThePreferencesDialog")
  const _component_TheLoginDialog = _resolveComponent("TheLoginDialog")
  const _component_TheSignupDialog = _resolveComponent("TheSignupDialog")
  const _component_TheTeamAddDialog = _resolveComponent("TheTeamAddDialog")
  const _component_TheSponsorAddDialog = _resolveComponent("TheSponsorAddDialog")
  const _component_TheScheduleFilters = _resolveComponent("TheScheduleFilters")
  const _component_TheMainMenu = _resolveComponent("TheMainMenu")
  const _component_TheUserMenu = _resolveComponent("TheUserMenu")
  const _component_TheNotificationCenter = _resolveComponent("TheNotificationCenter")
  const _component_TheTeamSelectionDropdown = _resolveComponent("TheTeamSelectionDropdown")
  const _component_TheTeamDivisionDropdown = _resolveComponent("TheTeamDivisionDropdown")
  const _component_TheTeamPoolDropdown = _resolveComponent("TheTeamPoolDropdown")
  const _component_TheSponsorTypeDropdown = _resolveComponent("TheSponsorTypeDropdown")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.isAppReady)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: ["app", {'blur': _ctx.isDBLoading || _ctx.anyModalDialogVisible}],
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeAllDialogsAndPopups && _ctx.closeAllDialogsAndPopups(...args)))
        }, [
          _createVNode(_component_TheNavbar),
          _createVNode(_component_router_view),
          _createVNode(_component_ResizeObserver, { onNotify: _ctx.handleResize }, null, 8, ["onNotify"])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.isDBLoading || _ctx.anyModalDialogVisible)
      ? (_openBlock(), _createBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.isDBLoading)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    (_ctx.anyModalDialogVisible && _ctx.isAppReady)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode(_component_TheJoinTeamDialog, { ref: "joindialog" }, null, 512),
          _createVNode(_component_ThePreferencesDialog, { ref: "prefsdialog" }, null, 512),
          _createVNode(_component_TheLoginDialog, {
            ref: "logindialog",
            username: _ctx.loginUsername
          }, null, 8, ["username"]),
          _createVNode(_component_TheSignupDialog, {
            ref: "signupdialog",
            username: _ctx.signupUsername,
            teamCaptain: _ctx.signupTeamCaptain,
            name: _ctx.signupName,
            teams: _ctx.signupTeams
          }, null, 8, ["username", "teamCaptain", "name", "teams"]),
          _createVNode(_component_TheTeamAddDialog, { team: _ctx.addTeam }, null, 8, ["team"]),
          _createVNode(_component_TheSponsorAddDialog, { sponsor: _ctx.addSponsor }, null, 8, ["sponsor"]),
          _hoisted_5
        ]))
      : _createCommentVNode("", true),
    (_ctx.isAppReady)
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode(_component_TheScheduleFilters, { filterSetName: _ctx.activeFilterSet }, null, 8, ["filterSetName"]),
          _createVNode(_component_TheMainMenu, {
            onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleMainMenu(false)))
          }),
          _createVNode(_component_TheUserMenu, {
            onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleUserMenu(false))),
            onShowPrefsDialog: _cache[4] || (_cache[4] = ($event: any) => (_ctx.togglePreferencesDialog(true)))
          }),
          _createVNode(_component_TheNotificationCenter, { ref: "notificationcenter" }, null, 512),
          _createVNode(_component_TheTeamSelectionDropdown),
          _createVNode(_component_TheTeamDivisionDropdown),
          _createVNode(_component_TheTeamPoolDropdown),
          _createVNode(_component_TheSponsorTypeDropdown)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}